import { Link } from 'react-router-dom';
import Wordmark from './Wordmark';

const cols = [
  { title: 'Platform',  items: [['Locations', '/featured-locations'], ['How it works', '/how-it-works'], ['List your spot', '/onboarding'], ['Request a spot', '/request-location'], ['Sign in', '/login']] },
  { title: 'Company',   items: [['About', '#'], ['Press', '#'], ['Contact', 'mailto:hi@goaround.io']] },
  { title: 'Legal',     items: [['Terms', '#'], ['Privacy', '#'], ['Cancellation', '#']] },
] as const;

export default function Footer() {
  return (
    <footer style={{ padding: '80px 0 36px', borderTop: '1px solid var(--line)' }}>
      <div className="container">
        <div className="footer-grid">

          <div>
            <Wordmark size={32} />
            <p style={{ color: 'var(--ink-soft)', marginTop: 20, maxWidth: 320, fontSize: 15, lineHeight: 1.5 }}>
              The team social platform for NYC teams. We handle the tab, the RSVPs, and the receipt. You just show up.
            </p>
          </div>
          {cols.map((c) => (
            <div key={c.title}>
              <div className="mono" style={{ fontSize: 11, letterSpacing: '0.14em', textTransform: 'uppercase', color: 'var(--ink-soft)', marginBottom: 18 }}>{c.title}</div>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 10 }}>
                {c.items.map(([label, href]) => (
                  <li key={label}>
                    {href.startsWith('/') ? (
                      <Link to={href} style={{ fontSize: 15 }}>{label}</Link>
                    ) : (
                      <a href={href} style={{ fontSize: 15 }}>{label}</a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div
          aria-hidden
          className="display"
          style={{
            fontSize: 'clamp(80px, 18vw, 280px)',
            lineHeight: 0.85,
            letterSpacing: '-0.05em',
            color: 'var(--ink)',
            borderTop: '1.5px solid var(--ink)',
            paddingTop: 24,
          }}
        >
          Goaround<span style={{ color: 'var(--primary)' }}>.</span>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 32, gap: 16, flexWrap: 'wrap' }}>
          <span className="mono" style={{ fontSize: 11, color: 'var(--ink-soft)', letterSpacing: '0.08em' }}>© 2026 Goaround · Made in NYC · Socialize responsibly.</span>
          <span className="mono" style={{ fontSize: 11, color: 'var(--ink-soft)', letterSpacing: '0.08em' }}>v 0.2 · Manhattan only · for now</span>
        </div>
      </div>
      <style>{`
        .footer-grid { display: grid; grid-template-columns: 1.6fr 1fr 1fr 1fr; gap: 48px; padding-bottom: 56px; }
        @media (max-width: 860px) {
          .footer-grid { grid-template-columns: 1fr 1fr; gap: 32px; padding-bottom: 40px; }
          .footer-grid > :first-child { grid-column: 1 / -1; }
        }
        @media (max-width: 480px) {
          .footer-grid { grid-template-columns: 1fr; }
        }
      `}</style>
    </footer>
  );
}
